import { SET_UNIX_BEGIN } from 'containers/Player/actions/player/constants';

const initialState = {
  unixBegin: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_UNIX_BEGIN:
      return {
        unixBegin: action.payload,
      };
    default:
      return state;
  }
};
